
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  title: string;
  description: string;
  showButton?: boolean;
}

export const EmptyState = ({ title, description, showButton = true }: EmptyStateProps) => {
  return (
    <div className="text-center py-12">
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-muted-foreground mb-4">{description}</p>
      {showButton && (
        <Button asChild className="bg-godyspo-gold text-black hover:bg-godyspo-gold/90">
          <Link to="/seller/properties/new">Create Your First Deal</Link>
        </Button>
      )}
    </div>
  );
};
